import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["item"];

  connect() {
    const checkedInput = this.element.querySelector("input[checked]");
    checkedInput.parentElement.classList.add("ring", "ring-offset-1");
  }

  check(event) {
    this.itemTargets.forEach((item) => {
      item.classList.remove("ring", "ring-offset-1");
    });

    event.currentTarget.classList.add("ring", "ring-offset-1");
    const input = event.currentTarget.querySelector("input");
    input.checked = true;
  }
}
